import EventBus from './event-bus';
import { EVENTS, PRODUCT_TYPES } from './constants';
import ClientService from './client-service';
import ModalService from './modal-service';
import ModalReservation from '../components/modal-reservation.vue';
import AdminModalReservation from '../admin-components/admin-modal-reservation.vue';
import ClientSignupLogin from '../components/client-signup-login.vue'
import ClientForgotPass from '../components/client-forgot-pass.vue'
import ProductModal from '../components/product-modal.vue';
import ProductVitrine from '../components/product-vitrine.vue'
import UiService from './ui-service';
import UrlService from './url-service';
import EditAddress from '../checkout/EditAddress.vue';
import CheckoutTicket from '../ticket/checkout-ticket.vue';
import ModalSisterShops from '../components/modal-sister-shops.vue';
import LandingModal from '../checkout/landing-modal.vue'
import LandingModal2 from '../checkout/landing-modal2.vue'
import CheckoutOrder from '../checkout/CheckoutOrder.vue';
import ShopService from './shop-service'
import growl from './growl';
import CartService from './cart-service'
import ChooseImageModal from '../components/ChooseImageModal.vue'

export default {
	editAddress,
	showReservationModal,
	showAdminReservationModal,
	openLandingModal,
	openCheckoutModal,
	openTicketModal,
	showSisterShopsModal,
	showClientForgotPassModal,
	showClientSignupModal,
	showClientLoginModal,
	showItemModal,
	showChooseImageModal,
}

    function showChooseImageModal(options) {
        return ModalService.open(ChooseImageModal, options, {}, ['autoWidth']);
    }

	function editAddress(address, client) {
		let modal = ModalService.open(EditAddress,
			{ address, order: { client} },
			{
				go(direction) {
					modal.dismiss()
				},
				'set-address'(address) {
					modal.close(address);
				},
			},
		);
	}

    function showReservationModal() {
		ModalService.open(ModalReservation);
	}

    function showAdminReservationModal() {
		ModalService.open(AdminModalReservation);
	}

	function openLandingModal() {
		let newDesign = ShopService.shop.info.checkoutHome;
		if (!newDesign) {
			ModalService.open(LandingModal, { order: CartService.cart }, {}, [], true);
		} else {
			ModalService.open(LandingModal2, { order: CartService.cart }, {}, [], true);
		}
	}

	function openCheckoutModal() {
		let shop = ShopService.shop;
		if (!shop) {
			growl.error('Aucun restaurant spécifié')
			return;
		}
		if (CartService.cart.SaleAreaId == ShopService.SALE_AREAS.RESTAURANT) {
			unsecureOpenCheckoutModal(CartService.cart);
		} else {
			ClientService.requestLoginAsync()
			.then((isAuthenticated) => {
				if (isAuthenticated) {
					unsecureOpenCheckoutModal(CartService.cart);
				} else {
					EventBus.$once(EVENTS.clientLogin, () => {
						unsecureOpenCheckoutModal(CartService.cart);
					});
				}
			})
		}
	}

	function unsecureOpenCheckoutModal(order) {
		ModalService.open(CheckoutOrder, { order })
	}

	function openTicketModal(ticket) {
		return ModalService.open(CheckoutTicket, { ticket })
	}

	function showSisterShopsModal(shop) {
		ModalService.open(ModalSisterShops, { shop });
	}

	function showClientForgotPassModal(email) {
		ModalService.open(ClientForgotPass, { email }).result.finally(() => showClientLoginModal());
	}

	function showClientSignupModal(showCheckout = false) {
		return showClientSignupLoginModal('signup', showCheckout);
	}

	function showClientSignupLoginModal(mode, showCheckout) {
		let showLanding = false;
		if (showCheckout && CartService.cart.isAtLanding) {
			showLanding = true;
		}
		let result = ModalService.open(ClientSignupLogin,{ mode }).result;
		result.then(() => showCheckoutOrLanding(showCheckout, showLanding));
		return result;
	}

	function showClientLoginModal(showCheckout = false) {
		return showClientSignupLoginModal('login', showCheckout);
	}

	function showCheckoutOrLanding(showCheckout, showLanding) {
		if (!showCheckout) {
			return;
		}
		if (!showLanding) {
			openCheckoutModal();
		} else {
			openLandingModal();
		}
	}

	function showItemModal(cart, item, vitrine, inMenu = false) {
		if (!vitrine) {
			ModalService.open(ProductModal, { inMenu, cart, cartItem: CartService.itemToCartItem(item) }, {}, ['modalProd optionProd']);
			return;
		}
		ModalService.open(ProductVitrine, { cart, cartItem: CartService.itemToCartItem(item) }, {}, ['modalProductVitrine modalMobileFull centered'])
		.result
		.catch((err)=>console.log('modal vitrine dismissed',err))
		.then((cartItem) => {
			if (cartItem?.product.ty == PRODUCT_TYPES.Menu) {
				UrlService.go({name:'carte',params:{tid: cartItem.tid}});
			} else if (cartItem) {
				UiService.selectItem(cart, cartItem);
			}
		});
	}
